import scandicDevLogo from "../assets/scandicdev.svg";

export default function ScandicDevLogo({ className = "" }) {
  return (
    <img
      src={scandicDevLogo}
      alt="ScandicDev"
      className={`block ${className}`}
    />
  );
}
